import { useQuery } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";

const useCompany = (companyId) => {
  return useQuery({
    queryKey: ["company", companyId],
    queryFn: () => {
      return apiClient.get(`companies/${companyId}`);
    },
  });
};

export { useCompany };
